exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.estilo-grilla[data-v-4c255a4e] {\n  width: 100%;\n  height: 1024px;\n  font-family: 'Asap', sans-serif;\n}\n", ""]);

// exports
